import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Papirnati Cthulhu",
  "description": "",
  "published": "2007-04-01T00:00:00.000Z",
  "redirect_from": ["/blog/papirnati-cthulhu/swizec/246"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Preko MSNja mi je bila pokazana `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=ACP/submode=ACP_news//"
      }}>{`povezava`}</a>{`. Zanimiva `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=ACP/submode=ACP_news//"
      }}>{`povezava`}</a>{`. Govori se, da vsebuje skrivnost izdelave Cthulhuja iz papirja, skupaj z izrezki in dvoumnimi navodili, toÄno kot bi si Älovek Å¾elel. Edina teÅ¾ava je, da slike niso v visoki loÄljivosti zatorej rezultat ni videti preveÄ roÅ¾nat.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      